import React from 'react';
import BlockTypes from '../../types/BlockTypes';
import createStore from '../utils/createStore';
import DragWrapper from './components/DragWrapper';
import './style.css';
import { DndProvider } from 'react-dnd';
var DRAGGABLE_BLOCKS = [BlockTypes.UNSTYLED, BlockTypes.TODO, BlockTypes.TABLE, BlockTypes.H1, BlockTypes.H2, BlockTypes.H3, BlockTypes.IMAGE, BlockTypes.IMAGE_GALLERY, BlockTypes.FILE, BlockTypes.CODES, BlockTypes.QUOTES, BlockTypes.HINTS, BlockTypes.UL_LI, BlockTypes.OL_LI, BlockTypes.EMBED, BlockTypes.EMBED_PLACEHOLDER, BlockTypes.INTEGRATION_TILE, BlockTypes.DATABASE];
var DROPPABLE_BLOCKS = [].concat(DRAGGABLE_BLOCKS, [BlockTypes.SEPARATOR]); // To handle Image while Image Gallery is behind a feature flag

function isDragOrDroppable(editor, DndBlocks, _ref) {
  var key = _ref.key,
      type = _ref.type;
  return DndBlocks.some(function (blockType) {
    if (type === BlockTypes.IMAGE) {
      return editor.value.document.getParent(key).type !== BlockTypes.IMAGE_GALLERY;
    }

    return blockType === type;
  });
}

export default function DndLinePlugin() {
  var store = createStore({
    isDraggingNode: false,
    highlightedBlock: null
  });
  return [{
    renderEditor: function renderEditor(props, editor, next) {
      var children = next();
      return React.createElement(DndProvider, null, children);
    },
    renderBlock: function renderBlock(props, editor, next) {
      // showDragButton control the rendering of the block action
      // In readOnly mode we want canDrop to be false and showDragButton to be true in order to render the block action
      // Then in the DragButton we prevent dragConnector to set up
      var showDragButton = isDragOrDroppable(editor, DRAGGABLE_BLOCKS, props.node);
      var showFullWidthButton = editor.query('canApplyFullWidth', props.node);
      var canDragOrDrop = !editor.readOnly && isDragOrDroppable(editor, DROPPABLE_BLOCKS, props.node);
      return showFullWidthButton || showDragButton || canDragOrDrop ? React.createElement(DragWrapper, Object.assign({
        store: store,
        showDragButton: showDragButton,
        canDragOrDrop: canDragOrDrop,
        showFullWidthButton: showFullWidthButton
      }, props), next()) : next();
    },
    commands: {
      highlightBlock: function highlightBlock(editor, node) {
        return store.updateItem('highlightedBlock', node);
      }
    },
    onDrop: function onDrop(event, editor, next) {
      event.preventDefault();
      return true;
    }
  }];
}